<template>
  <div>
    <base-header v-once :pageName="`상담 리포트 확인`" :popup="true"></base-header>
    <section id="wrap" class="counsult">
      
      <ul class="group-list" v-if="counselList && counselList.length > 0">
        <li v-for="(item, index) in counselList" :key="index">
          <p>
            <strong>{{item.custNm}}</strong>
          </p>
          <div>
            <ul class="consult_list">
              <li>
                <span class="planner">{{ item.orgnzPstnNm }}</span>
                <span>{{ item.cnslUserNm }}</span>
              </li>
              <li>
                <span class="report">리포트 발송</span>
                <span class="count">{{ item.sendCnt }}</span>
              </li>
              <li>
                <span class="answer">상담 응답</span>
                <span class="count">{{ item.ansCnt }}</span>
              </li>
            </ul>
          </div>
        </li>
      </ul>

      <div v-else-if="!isLoading && counselList.length === 0" class="no-data" style="text-align: center; padding: 30px 0; color: #999;">
        상담 내역이 없습니다.
      </div>

      <div v-if="isLoading" style="text-align: center; padding: 20px 0; color: #666;">
        데이터를 불러오는 중입니다...
      </div>

    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchUserId: '',         //  추가: 이전 화면에서 넘어온 사번을 저장할 공간
      counselList: [],
      page: 1,           // 현재 페이지 번호
      pageSize: 10,      // 한 번에 불러올 데이터 개수
      isLoading: false,  // API 통신 중인지 여부 (중복 호출 방지)
      isEnd: false       // 마지막 페이지인지 여부 (더 이상 불러올 데이터가 없음)
    };
  },
  created() {
    this.searchUserId = this.$route.query.searchUserId || ''; 
  },
  methods: {
    // API 호출하여 데이터 가져오기
    fetchData() {
      // 이미 로딩 중이거나, 마지막 페이지까지 다 불러왔다면 더 이상 호출하지 않음
      if (this.isLoading || this.isEnd) return; 
      
      this.isLoading = true;

      // 💡 백엔드 API에 페이지 정보를 전달해야 합니다. (API 파라미터명은 백엔드 스펙에 맞게 수정하세요)
      const params = {
        page: this.page,
        size: this.pageSize
      };

      if (this.searchUserId) {
        params.searchUserId = this.searchUserId;
      }

      // this.$api.counsel.counselReportList(params) 형태로 파라미터를 넘긴다고 가정
      this.$api.counsel.counselReportList(params)
        .then((res) => {
          console.log("조회된 데이터:", res);
          const newList = res.counselList || [];

          // 새로 받아온 데이터가 10개(pageSize)보다 적다면? -> 다음 페이지는 없다는 뜻!
          if (newList.length < this.pageSize) {
            this.isEnd = true; 
          }

          // 기존 리스트 뒤에 새로 받아온 리스트를 이어 붙입니다 (Spread Syntax 활용)
          this.counselList = [...this.counselList, ...newList];
          
          // 다음 스크롤을 위해 페이지 번호 1 증가
          this.page += 1; 
        })
        .catch((error) => {
          alert(error.rtMsg || "리스트를 불러오는 중 오류가 발생했습니다.");
        })
        .finally(() => {
          // 통신이 성공하든 실패하든 로딩 상태는 해제
          this.isLoading = false; 
        });
    },

    // 스크롤 감지 이벤트 핸들러
    handleScroll() {
      // 현재 화면의 스크롤 위치를 계산
      const scrollY = window.scrollY || window.pageYOffset;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      // 화면 밑바닥에서 100px 위로 올라왔을 때 미리 다음 데이터를 호출 (사용성 개선)
      if (scrollY + windowHeight >= documentHeight - 100) {
        this.fetchData();
      }
    }
  },
  mounted() {
    // 1. 컴포넌트가 마운트되면 최초 1페이지 데이터(10개)를 불러옵니다.
    this.fetchData();

    // 2. 윈도우 스크롤 이벤트를 등록합니다.
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 💡 매우 중요: 다른 페이지로 이동할 때 스크롤 이벤트가 계속 남아있지 않도록 제거해 줍니다. (메모리 누수 방지)
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>